import { atom,useAtom } from 'jotai'

const useLoadingAtom = atom(false)

export const useLoading = () => {
  return useAtom(useLoadingAtom)
}
